import { Box, Grid, IconButton, makeStyles, Tooltip } from '@material-ui/core'
import UpdateIcon from '@material-ui/icons/Update'
import moment from 'moment'
import { useSnackbar } from 'notistack'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { adminDateRangeConstants } from '../../../../constants/formConstants/adminFormConstants'
import { allInvoiceHeadCells, paidInvoiceHeadCells } from '../../../../constants/headCells/invoiceHeadCells'
import { getAllInvoice, updateOrder } from '../../../../services/plansService'
import Button from '../../../commons/Button/Button'
import GenerateFormHook from '../../../commons/GenerateFormHook'
import ScreenWrapper from '../../../commons/ScreenWrapper'
import Table from '../../../commons/Table/dataTable/Table'
import Text from '../../../commons/Text'

const useStyles = makeStyles(theme => ({
    svg: {
        '&.MuiSvgIcon-root': {
            color: `${theme.palette.ascents.white} !important`
        }
    }
}))

const AdminInvoiceDetailsScreen = () => {
    const classes = useStyles()
    const jwt = useSelector(state => state.auth.admin.jwt)
    const [allInvoiceData, setAllInvoiceData] = React.useState([])
    const [paidInvoiceData, setPaidInvoiceData] = React.useState([])
    const [allInvoiceDataIsLoading, setAllInvoiceDataIsLoading] = React.useState(false)
    const { enqueueSnackbar } = useSnackbar()
    const methods = useForm();
    const [searchBtn1Loading, setSearchBtn1Loading] = React.useState(false)

    const handleFormSubmit = (data) => {
        fetchAllInvoice(data.fromDate, data.toDate)
    }

    const fetchAllInvoice = (fromDate, toDate, onSuccess = () => { }) => {
        setAllInvoiceDataIsLoading(true)
        setSearchBtn1Loading(true)
        getAllInvoice({
            fromDate,
            jwt,
            toDate,
        }).then(response => {
            if (response) {
                if (response.payload) {
                    setAllInvoiceData(response.payload)
                    setPaidInvoiceData(response.payload.filter(invoice => invoice.isPaid === 1))
                    onSuccess()
                }
            }
            else {
                enqueueSnackbar('No data found', {
                    variant: 'error'
                })
            }
            setAllInvoiceDataIsLoading(false)
            setSearchBtn1Loading(false)
        })
    }

    const handleInvoiceUpdateOrder = eachData => () => {
        setAllInvoiceDataIsLoading(true)
        updateOrder(eachData.invoiceId).then(response => {
            if (response) {
                fetchAllInvoice(moment(methods.getValues().fromDate).format('YYYY-MM-DD'), moment(methods.getValues().toDate).format('YYYY-MM-DD'), () => enqueueSnackbar('Invoice status updated successfully!', {
                    variant: 'success'
                }))
            }
            else {
                enqueueSnackbar('Failed to update invoice status!', {
                    variant: 'error'
                })
                setAllInvoiceDataIsLoading(false)
            }
        })
    }

    React.useEffect(() => {
        methods.reset({
            fromDate: '2022-01-01',
            toDate: moment().format('YYYY-MM-DD'),
        })
        fetchAllInvoice('2022-01-01', moment().format('YYYY-MM-DD'))
    }, [])


    return (
        <ScreenWrapper
            pageTitle='All Invoices'
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(handleFormSubmit)}>
                            <Grid container spacing={3}>
                                <Grid item xs={4}>
                                    <GenerateFormHook control={methods.control} formConstant={adminDateRangeConstants()} />
                                </Grid>
                                <Grid item xs={8}>
                                    <Box display='flex' alignItems='center' height={'100%'}>
                                        <Button full variant='contained' type='submit' color='primary' isLoading={searchBtn1Loading}>{!searchBtn1Loading ? 'Search' : 'Searching...'}</Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </form>
                    </FormProvider>
                    <Table
                        headCells={allInvoiceHeadCells}
                        tableData={allInvoiceData}
                        crud={{}}
                        tableName='All Invoices'
                        isLoading={allInvoiceDataIsLoading}
                        showDownloadButton
                        ActiveComponent={({ eachData }) => (
                            eachData.isPaid === 1 ? (
                                <Text ascent='green'>
                                    Paid
                                </Text>
                            ) : (
                                <Tooltip title='Update Invoice Status'>
                                    <IconButton onClick={handleInvoiceUpdateOrder(eachData)}>
                                        <UpdateIcon fontSize='small' color='primary' className={classes.svg} />
                                    </IconButton>
                                </Tooltip>
                            )
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Table
                        headCells={paidInvoiceHeadCells}
                        tableData={paidInvoiceData}
                        crud={{}}
                        tableName='All Paid Invoices'
                        isLoading={allInvoiceDataIsLoading}
                        showDownloadButton
                    />
                </Grid>
            </Grid>
        </ScreenWrapper>
    )
}

export default AdminInvoiceDetailsScreen